// src/pages/HomePage.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaHome, FaSearch, FaFutbol } from 'react-icons/fa';
import Navbar from '../components/Layout/Navbar';
import TopBar from '../components/Layout/TopBar';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-[#001B56]">
      <TopBar />
      <div className="sticky top-4 z-50 flex flex-col items-center w-full">
        <div className="relative w-[90vw] max-w-2xl">
          <Navbar />
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center"
        >
          {/* Animation de ballon de foot qui rebondit */}
          <motion.div
            animate={{ 
              y: [0, -20, 0],
              rotate: [0, 360, 720]
            }}
            transition={{ 
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut"
            }}
            className="inline-block mb-8"
          >
            <FaFutbol className="text-8xl text-blue-600" />
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.2 }}
            className="text-9xl font-bold text-white4"
          >
            404
          </motion.h1>

          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            className="text-4xl font-bold text-white mb-6"
          >
            Hors-jeu !
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6 }}
            className="text-xl text-white mb-8 max-w-2xl mx-auto"
          >
            La page que vous cherchez semble avoir été transférée ou n'existe plus. 
            Retournons sur le terrain !
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8 }}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <Link
              to="/"
              className="flex items-center gap-2 px-8 py-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-semibold"
            >
              <FaHome />
              Retour à l'accueil
            </Link>
            
            <Link
              to="/equipes"
              className="flex items-center gap-2 px-8 py-4 border-2 border-blue-600 text-blue-600 rounded-lg hover:bg-blue-600 hover:text-white transition-colors font-semibold"
            >
              <FaFutbol />
              Voir nos équipes
            </Link>
          </motion.div>

          {/* Suggestions */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1 }}
            className="mt-16 bg-white rounded-xl shadow-lg p-8"
          >
            <h3 className="text-2xl font-bold text-gray-800 mb-6 flex items-center justify-center gap-3">
              <FaSearch />
              Peut-être cherchiez-vous...
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <Link
                to="/fanzone/profil"
                className="p-6 border border-gray-200 rounded-lg hover:border-blue-300 hover:shadow-md transition-all"
              >
                <div className="text-3xl mb-3">🎮</div>
                <h4 className="font-bold text-lg mb-2">Fan Zone</h4>
                <p className="text-gray-600">Jeux, quiz et défis pour les supporters</p>
              </Link>

              <Link
                to="/boutique"
                className="p-6 border border-gray-200 rounded-lg hover:border-blue-300 hover:shadow-md transition-all"
              >
                <div className="text-3xl mb-3">🛍️</div>
                <h4 className="font-bold text-lg mb-2">Boutique</h4>
                <p className="text-gray-600">Maillots et produits officiels</p>
              </Link>

              <Link
                to="/galerie"
                className="p-6 border border-gray-200 rounded-lg hover:border-blue-300 hover:shadow-md transition-all"
              >
                <div className="text-3xl mb-3">📸</div>
                <h4 className="font-bold text-lg mb-2">Galerie</h4>
                <p className="text-gray-600">Photos et moments forts du club</p>
              </Link>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFoundPage;
  